import { generateLogoWithIdeogram } from './ideogramService';

export interface AIThumbnailOption {
  id: string;
  url: string;
}

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const aiThumbnailService = {
  async generate(options: { description: string; count?: number; title?: string }): Promise<AIThumbnailOption[]> {
    const { description, count = 4, title } = options;
    if (!description || !description.trim()) {
      throw new Error('Please enter a description for the thumbnail');
    }

    // Try backend endpoint first, fallback to placeholder Ideogram service
    try {
      const res = await fetch(`${API_BASE}/ai/thumbnails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: description, count, title })
      });
      if (res.ok) {
        const data = await res.json();
        const imgs: AIThumbnailOption[] = (data?.images || []).map((it: any, i: number) => ({
          id: String(it?.id ?? i),
          url: String(it?.url)
        })).filter((x: AIThumbnailOption) => !!x.url);
        if (imgs.length > 0) return imgs;
      }
    } catch (_) {
      // ignore and fallback
    }

    // Fallback: placeholder URLs via existing ideogramService
    const urls = await generateLogoWithIdeogram(description);
    return urls.slice(0, count).map((url, i) => ({ id: `${i}`, url }));
  }
};
